import ResidenceType from '@/models/ResidenceType/ResidenceType';
import BossModel from "@/models/BossModel";
import Composition from '@/models/Product/Detail/Composition/Composition';
import Product from '@/models/Product/Product';
import Image from '@/models/Product/Detail/Image/Image';

export default class Detail extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/detail';

    /**
     *
     * @type {string}
     */
    static entity = 'productDetails';


    static fields() {
		return {
			id: this.number(null).nullable(),
			product_id: this.number(null).nullable(),
			residence_type_id: this.attr(null),
			code: this.attr(null),
			name: this.attr(null),
            agent_name: this.attr(null),
			room_type: this.attr(null),
			is_active: this.boolean(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			created_by: this.attr(null),
			is_created_on_the_fly: this.boolean(null).nullable(),
			sort_order: this.number(null).nullable(),
			website_text: this.attr(null),
			website_description: this.attr(null),
			website_title: this.attr(null),
            product: this.belongsTo(Product, 'product_id'),
            residenceType: this.belongsTo(ResidenceType, 'residence_type_id'),
            compositions: this.hasMany(Composition, 'product_detail_id'),
            images: this.hasMany(Image, 'product_detail_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    Product(){
        return Product.find(this.product_id);
    }

    /**
     *
     * @returns {null|boolean|*}
     */
    Residence(){
        if (this.residence_type_id) {
            return ResidenceType.find(this.residence_type_id);
        }

        return null;
    }
}
